'use client';

import React from 'react';

export interface DemoContextType {
  id: string;
  state: Record<string, any>;
  setState: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  activeControlId: string | null;
  setActiveControlId: React.Dispatch<
    React.SetStateAction<string | null>
  >;
  initialValuesRef: React.MutableRefObject<Record<string, any>>;
}

const DemoContext = React.createContext<DemoContextType>({
  id: '',
  state: {},
  setState: () => {},
  activeControlId: null,
  setActiveControlId: () => {},
  initialValuesRef: { current: {} },
});

export function useDemoContext() {
  const context = React.useContext(DemoContext);

  if (!context) {
    throw new Error(
      'ControlContainer must be used within a DemoContext provider'
    );
  }

  return context;
}

export default DemoContext;
